import { ComponentProps, FC } from 'react'
import Clipboard from 'react-clipboard.js'

import Button from './Button'

const CopyButton = Button.withComponent(Clipboard)

type Props = {
  dataClipboardTarget: string
} & ComponentProps<typeof Button>

const CopyToClipboardButton: FC<Props> = ({
  children,
  dataClipboardTarget,
  ...props
}) => {
  return (
    <CopyButton
      data-clipboard-target={dataClipboardTarget}
      type="button"
      uppercase={false}
      {...props}
    >
      {children || 'Copy'}
    </CopyButton>
  )
}

export default CopyToClipboardButton
